export default __webpack_public_path__ + "static/media/Pale Hands.04111f3f.png";